<app-menu-common url="sales"></app-menu-common>

<div class="tracking-page">

  <!-- Entête fixe : titre et actions, puis les filtres ; seule la liste défile dessous (documentation.html#front.sales.delivery-tracking) -->
  <div class="toolbar-card">

    <div class="header-row">
      <div class="toolbar-title">
        <mat-icon class="toolbar-icon">local_shipping</mat-icon>
        <span>Suivi des livraisons</span>
      </div>

      <span class="spacer"></span>

      <span class="badge-count big" matTooltip="Pièces lues avec les critères de la barre (types, client, produit, dates)">{{ pieces.length }} pièce{{ pieces.length > 1 ? 's' : '' }}</span>

      <button mat-stroked-button class="hdr-btn" (click)="load()" [disabled]="loading" matTooltip="Relire le serveur">
        <mat-icon [class.spinning]="loading">refresh</mat-icon>Actualiser
      </button>
      <button mat-stroked-button class="hdr-btn" (click)="folded = !folded" [matTooltip]="folded ? 'Afficher les lignes de chaque pièce' : 'Ne garder que les en-têtes des pièces'">
        <mat-icon>{{ folded ? 'unfold_more' : 'unfold_less' }}</mat-icon>{{ folded ? 'Déplier les lignes' : 'Replier les lignes' }}
      </button>
      @if (filter.product && !orderId) {
        <button mat-stroked-button class="hdr-btn" (click)="checkProductRemainders()" matTooltip="Cocher, pour les annuler, toutes les lignes de reste du produit cherché (produit arrêté, par exemple)">
          <mat-icon>playlist_add_check</mat-icon>Cocher les restes du produit
        </button>
      }
      <button mat-flat-button class="hdr-btn act-deliver" [disabled]="selectedBl.size === 0" (click)="markDelivered()"
        matTooltip="Déclarer livrés les BL programmés cochés, comme au retour de tournée">
        <mat-icon>task_alt</mat-icon>Passer à livré ({{ selectedBl.size }})
      </button>
      <button mat-flat-button class="hdr-btn act-cancel" [disabled]="cancelCount === 0" (click)="cancelRemaining()"
        matTooltip="Un bon d'annulation par commande pour les lignes de reste cochées : définitif, jamais facturé">
        <mat-icon>block</mat-icon>Annuler le reste ({{ cancelCount }})
      </button>
    </div>

    <div class="filters-row">
      <div class="filter-item">
        <label class="filter-label">Afficher</label>
        <div class="kind-toggles" role="group" aria-label="Pièces affichées">
          @for (k of kinds; track k) {
            <button type="button" class="kind-btn" [ngClass]="'k-' + k" [class.on]="!orderId && isKind(k)" [attr.aria-pressed]="!orderId && isKind(k)" (click)="toggleKind(k)" [matTooltip]="kindTooltip(k)">
              {{ kindLabels[k] }}@if (isKind(k) || orderId) {<span class="kind-count">{{ countKind(k) }}</span>}
            </button>
          }
          <button type="button" class="kind-btn k-rental" [class.on]="!orderId && filter.rental" [attr.aria-pressed]="!orderId && filter.rental" (click)="toggleRental()"
            matTooltip="Ajouter les BL des dossiers de location, livrés ou programmés selon les boutons allumés ; jamais de reste à livrer (un matériel loué se pose et se reprend)">
            Location@if (filter.rental || orderId) {<span class="kind-count">{{ countRental() }}</span>}
          </button>
          <button type="button" class="kind-btn k-canceled" [class.on]="!orderId && filter.canceled" [attr.aria-pressed]="!orderId && filter.canceled" (click)="toggleCanceled()"
            matTooltip="Ajouter les BL des commandes annulées (jamais leur reste : une commande annulée n'a plus rien à livrer)">
            Commandes annulées
          </button>
        </div>
      </div>

      <div class="filter-item product-filter">
        <label class="filter-label" title="Douchette ou saisie du code-barres, ou recherche par nom : toutes les pièces qui portent ce produit, quel que soit son conditionnement">Produit</label>
        <app-search-product width="250px" placeholder="Scanner ou chercher un produit" (blurEmitter)="onProductText($event)" (selectProductEmitter)="onProductSelected($event)"></app-search-product>
      </div>

      <div class="filter-item partner-filter">
        <label class="filter-label">Client</label>
        <app-search-partner [currentPartner]="customer" width="230px" [showSelectionInInput]="true" (partnerChange)="customerChange($event)"></app-search-partner>
      </div>

      <div class="filter-item">
        <label class="filter-label" title="Toutes les pièces d'une commande, livrées, programmées et reste : Tab ou Entrée filtre, l'icône ouvre la commande dans un nouvel onglet">Id commande</label>
        <smart-input #orderIdNav width="100px" type="number" placeholder="N°" icon="link"
          iconClass="custom-icon-button primary" [iconHref]="orderIdHref" iconTarget="_blank"
          [(ngModel)]="orderIdText" (valueChange)="onOrderIdChange($event)"
          (blurred)="onOrderIdBlur($event)" (enterPressed)="onOrderIdValidate($event)" />
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-store" title="Établissement du poste où la commande a été saisie">Magasin&nbsp;/&nbsp;Ets.</label>
        <select id="flt-store" class="custom-select store-select" [(ngModel)]="filter.store" (change)="onSelectChange()">
          @for (store of stores; track store) {
            <option [value]="store.id">{{ store.name }}&nbsp;{{ (store.id ?? 0) > 0 ? store.id : '' }}</option>
          }
        </select>
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-user" title="Employé qui a saisi la commande">Employés</label>
        <select id="flt-user" class="custom-select user-select" [(ngModel)]="filter.user" (change)="onSelectChange()">
          @for (user of users; track user) {
            <option [value]="user.id">{{ ((user.firstname ?? '') + ' ' + (user.lastname ?? '')).trim() }}</option>
          }
        </select>
      </div>

      <div class="filter-item date-filter" title="Date de validation de la commande, pour toutes les pièces (pas la date du BL)">
        <label class="filter-label">Validée du</label>
        <app-select-date [date]="filter.from" (dateChange)="dateChange($event, 'from')"></app-select-date>
      </div>

      <div class="filter-item date-filter" title="Date de validation de la commande, pour toutes les pièces (pas la date du BL)">
        <label class="filter-label">au</label>
        <app-select-date [date]="filter.to" (dateChange)="dateChange($event, 'to')"></app-select-date>
      </div>

      <div class="period-presets" role="group" aria-label="Raccourcis de période">
        @for (p of periods; track p.key) {
          <button type="button" class="period-btn" [class.active]="isPeriod(p.key)" [title]="p.title" (click)="setPeriod(p.key)">{{ p.label }}</button>
        }
      </div>

      <div class="toolbar-actions">
        <button mat-flat-button class="error btn-inline" aria-label="Effacer" title="Effacer les filtres : programmés et restes, toutes dates" (click)="onClear()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="table-card list-card">
    <div class="table-header-bar">
      <div class="table-title">
        <mat-icon>inventory_2</mat-icon>
        <span>Pièces</span>
        <span class="badge-count">{{ visible.length }}</span>
        @if (hiddenCount > 0) {
          <button type="button" class="hidden-chip" (click)="clearLocal()" matTooltip="Pièces que le magasin ou l'employé cachent : cliquer pour les afficher">+ {{ hiddenCount }} hors filtres</button>
        }
        @if (orderId) {
          <span class="order-chip">Commande {{ orderId }} : toutes ses pièces
            <button type="button" class="chip-x" aria-label="Quitter la commande" (click)="onOrderIdBlur('')"><mat-icon>close</mat-icon></button>
          </span>
        }
        @if (loadedAt) {
          <span class="loaded-at" matTooltip="Heure de la dernière lecture ; « Actualiser » relit le serveur">lue à {{ loadedAt | date:'HH:mm' }}</span>
        }
      </div>

      @if (productSummary; as s) {
        <div class="product-summary">
          <mat-icon class="ps-icon">qr_code_scanner</mat-icon>
          <span class="ps-name" [title]="productName">{{ productName }}</span>
          <span>: <b>{{ qtyFr(s.units) }}</b> unité{{ s.units > 1 ? 's' : '' }} attendue{{ s.units > 1 ? 's' : '' }} chez <b>{{ s.customers }}</b> client{{ s.customers > 1 ? 's' : '' }}</span>
          <span class="ps-detail">· {{ qtyFr(s.planned) }} programmée{{ s.planned > 1 ? 's' : '' }} · {{ qtyFr(s.remaining) }} à planifier@if (isKind('delivered')) { · {{ qtyFr(s.delivered) }} livrée{{ s.delivered > 1 ? 's' : '' }} }</span>
          @if (s.back > 0 || s.backDone > 0) {
            <span class="ps-detail">· reprises : {{ qtyFr(s.back) }} programmée{{ s.back > 1 ? 's' : '' }}@if (s.backCustomers) { chez {{ s.backCustomers }} client{{ s.backCustomers > 1 ? 's' : '' }} }@if (isKind('delivered')) { · {{ qtyFr(s.backDone) }} faite{{ s.backDone > 1 ? 's' : '' }} }</span>
          }
          <button type="button" class="chip-x" aria-label="Retirer le produit" matTooltip="Retirer le filtre produit" (click)="setProduct(null, '')"><mat-icon>close</mat-icon></button>
        </div>
      }
    </div>

    <div class="tracking-list" [class.folded]="folded">
      @if (visible.length > 0) {
        @if (!folded) {
          <div class="line-row cols-head">
            <div class="cell sel-cell"></div>
            <div class="cell">Article</div>
            <div class="cell">Conditionnement</div>
            <div class="cell">Code-barres</div>
            <div class="cell num" title="Quantité commandée sur la ligne">Commandé</div>
            <div class="cell num" title="Déjà livré (BL réalisés)">Livré</div>
            <div class="cell num" title="Sur un BL créé, pas encore livré">Programmé</div>
            <div class="cell num" title="Soldé par un bon d'annulation">Annulé</div>
            <div class="cell num strong" title="Ce que porte cette pièce : la ligne du BL, ou le reste à livrer">Qté</div>
            <div class="cell num" title="Qté × unités du conditionnement (carton, boîte…)">Unités</div>
            <div class="cell num" title="Quantité à annuler, cochée sur une ligne de reste">À annuler</div>
          </div>
        }

        @for (g of groups; track g.key) {
          <section class="cust-group">
            <div class="cust-head">
              <mat-icon class="cust-icon">person</mat-icon>
              <span class="cust-name" [title]="g.name">{{ g.name }}</span>
              @if (g.city) { <span class="cust-city">{{ g.city }}</span> }
              <span class="cust-count">{{ g.pieces.length }} pièce{{ g.pieces.length > 1 ? 's' : '' }}</span>
            </div>

            @for (v of g.pieces; track v.key) {
              <article class="piece" [ngClass]="'k-' + v.kind" [class.canceled-order]="v.canceledOrder">
                <div class="piece-head">
                  <span class="head-check">
                    @if (v.kind === 'planned') {
                      <mat-checkbox color="primary" [checked]="selectedBl.has(v.p.delivery_id!)" (change)="toggleBl(v, $event.checked)"
                        matTooltip="Cocher pour « Passer à livré »" aria-label="Sélectionner le BL"></mat-checkbox>
                    } @else if (v.kind === 'remaining') {
                      <mat-checkbox class="cancel-check" [checked]="pieceCancelState(v) === 'all'" [indeterminate]="pieceCancelState(v) === 'some'"
                        (change)="togglePieceCancel(v, $event.checked)" matTooltip="Cocher toutes les lignes de ce reste pour « Annuler le reste »" aria-label="Cocher tout le reste"></mat-checkbox>
                    }
                  </span>
                  <span class="kind-chip">{{ v.kind === 'delivered' ? 'Livré' : v.kind === 'planned' ? 'Programmé' : 'À livrer' }}</span>
                  <span class="piece-title">{{ v.title }}</span>
                  <span class="sep">·</span>
                  @if (v.rental) {
                    <span class="tag tag-rental">Location</span>
                    <a class="order-link" [routerLink]="['/rental', v.p.order_id]" matTooltip="Ouvrir le dossier de location">Dossier {{ v.p.order_id }}</a>
                  } @else {
                    <a class="order-link" [routerLink]="['/sales/quotation', v.p.order_id]" matTooltip="Ouvrir la commande">Cde {{ v.p.order_id }}</a>
                    @if (v.passage) {
                      <span class="tag tag-rental" [matTooltip]="'Ventes livrées avec le BL ' + v.passage + ' du dossier de location ' + v.p.passage_order + ' : ils passent à livré ensemble'">location · BL {{ v.passage }}</span>
                    }
                  }
                  <span class="sep">·</span>
                  @if (v.p.validated_day) {
                    <span class="validated" matTooltip="Date de validation de la commande : celle des filtres « Validée du / au »">validée le {{ dayFr(v.p.validated_day) }}</span>
                  } @else {
                    <span class="validated missing" matTooltip="La commande n'a pas de date de validation : elle n'apparaît que si « Validée du » est vide">validation absente</span>
                  }
                  @if (v.when) {
                    <span class="when" matTooltip="Date propre du BL ; les filtres portent sur la date de validation de la commande">({{ v.when }})</span>
                  }
                  @if (v.modeLabel) { <span class="mode-tag">{{ v.modeLabel }}</span> }
                  @if (v.p.datinvoicing) { <span class="tag tag-invoiced" matTooltip="Ce BL a sa facture">BL facturé</span> }
                  @if (v.kind !== 'remaining') {
                    <mat-icon class="proof" [class.ok]="v.p.has_proof" [matTooltip]="v.p.has_proof ? 'Scan du BL papier ou BL signé à l\'écran' : 'Ni scan du BL papier ni BL signé à l\'écran'">{{ v.p.has_proof ? 'task' : 'description' }}</mat-icon>
                  }
                  @if (v.p.order_state !== 'PREPARATION') {
                    <span class="state-pill" [ngClass]="v.stateColor" matTooltip="État de la commande">{{ v.stateLabel }}</span>
                  }
                  <span class="spacer"></span>
                  <span class="deliv" [title]="v.p.deliv_name + (v.p.deliv_street ? ' · ' + v.p.deliv_street : '') + ' · ' + v.p.deliv_city">{{ v.p.deliv_city }}</span>
                  @if (userShortName(v.p.id_user); as u) { <span class="emp" matTooltip="Employé qui a saisi la commande">{{ u }}</span> }
                  @if (v.passage) {
                    <button type="button" class="open-delivery" (click)="openPassage(v)" matTooltip="Ouvrir le passage dans la fenêtre de livraison location (matériel et ventes)" aria-label="Ouvrir le passage">
                      <mat-icon>open_in_new</mat-icon>
                    </button>
                  } @else {
                    <a class="open-delivery" [routerLink]="['/logistic/delivery', v.p.order_id]" [queryParams]="deliveryParams(v)"
                      [matTooltip]="v.kind === 'remaining' ? 'Ouvrir la livraison de la commande pour planifier ce reste' : 'Ouvrir ce BL dans la fenêtre de livraison'"
                      [attr.aria-label]="v.kind === 'remaining' ? 'Planifier' : 'Ouvrir le BL'">
                      <mat-icon>{{ v.kind === 'remaining' ? 'event_available' : 'open_in_new' }}</mat-icon>
                    </a>
                  }
                </div>

                @if (!folded) {
                  @for (lv of v.lines; track lv.l.id_order_l) {
                    <div class="line-row" [class.dim]="!lv.hit" [class.cancel-on]="v.kind === 'remaining' && isCancelChecked(lv)">
                      <div class="cell sel-cell">
                        @if (v.kind === 'remaining') {
                          <mat-checkbox class="cancel-check" [checked]="isCancelChecked(lv)" (change)="toggleCancel(v, lv, $event.checked)" aria-label="Annuler ce reste"></mat-checkbox>
                        }
                      </div>
                      <div class="cell name-cell" [title]="lv.article ? lv.name + ' — ' + lv.article : lv.name">{{ lv.name }}@if (lv.typLabel) {<span class="typ-tag">{{ lv.typLabel }}</span>}@if (lv.article) {<div class="article">{{ lv.article }}</div>}</div>
                      <div class="cell muted" [title]="lv.l.packaging_name ?? ''">{{ lv.l.packaging_name }}</div>
                      <div class="cell code-cell">{{ lv.l.barcode }}</div>
                      <div class="cell num">{{ qtyFr(lv.l.ordered) }}</div>
                      <div class="cell num muted">{{ lv.l.delivered ? qtyFr(lv.l.delivered) : '' }}</div>
                      <div class="cell num muted">{{ lv.l.planned ? qtyFr(lv.l.planned) : '' }}</div>
                      <div class="cell num muted">{{ lv.l.canceled ? qtyFr(lv.l.canceled) : '' }}</div>
                      <div class="cell num strong">{{ qtyFr(lv.l.qty) }}</div>
                      <div class="cell num muted">{{ lv.units !== null ? qtyFr(lv.units) + ' u.' : '' }}</div>
                      <div class="cell num cancel-cell">
                        @if (v.kind === 'remaining' && isCancelChecked(lv)) {
                          <input type="number" class="cancel-input" [class.bad]="isCancelBad(lv)" step="0.01" min="0.01" [max]="lv.l.qty"
                            [ngModel]="cancelQty(lv)" (ngModelChange)="setCancelQty(lv, $event)"
                            [title]="'Entre 0,01 et ' + qtyFr(lv.l.qty) + ', au centième'" aria-label="Quantité à annuler" />
                        }
                      </div>
                    </div>
                  } @empty {
                    <div class="line-row empty-lines"><div class="cell sel-cell"></div><div class="cell muted">Aucune ligne sur ce BL.</div></div>
                  }
                }
              </article>
            }
          </section>
        }
      } @else if (loading) {
        <div class="list-state">
          <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="4" color="primary"></mat-progress-spinner>
          <span>Chargement du suivi des livraisons…</span>
        </div>
      } @else {
        <div class="list-state">
          <mat-icon class="empty-icon">{{ loadFailed ? 'error_outline' : 'filter_alt_off' }}</mat-icon>
          @if (loadFailed) {
            <div class="empty-title">Lecture du suivi des livraisons en échec</div>
            <button mat-stroked-button color="primary" class="action-btn" (click)="load()"><mat-icon>refresh</mat-icon>Réessayer</button>
          } @else if (!orderId && !filter.kinds.length) {
            <div class="empty-title">Aucun type de pièce choisi</div>
            <div class="empty-subtitle">Allumez « Livrés », « Programmés » ou « Reste à livrer » (« Location » s'ajoute aux deux premiers).</div>
          } @else if (pieces.length) {
            <div class="empty-title">Aucune pièce pour ce magasin ou cet employé</div>
            <button mat-stroked-button color="primary" class="action-btn" (click)="clearLocal()"><mat-icon>clear</mat-icon>Tous les magasins et employés</button>
          } @else {
            <div class="empty-title">Aucune pièce avec ces critères</div>
            <button mat-stroked-button color="primary" class="action-btn" (click)="onClear()"><mat-icon>clear</mat-icon>Effacer les filtres</button>
          }
        </div>
      }
    </div>
  </div>
</div>
